import { Check, ConfirmModal, ConfirmModal2, CustomNav, CustomNavLink, CustomSplitPane, SystemInformation, showErrToast, showToast } from "components/Common"
import ModalConfigPrinter from "components/Common/Modals/ModalConfigPrinter"
import ModalPreview from "components/Common/Modals/ModalPreview"
import { ExportExtension, ModuleIds, permissionType, ReportAction, ReportResource, RESULT_STATE_Text, TestRequest_Test_Type } from "constant"
import { downloadFileWithName } from "helpers/api_helper2"
import { confirmValidPrint, confirmValidPrintVerSun, exportFileResult, getFilePrintResult, pingToPrintService, sendDataPrint } from "helpers/app-backend"
import { GetDataUrlReportConfig, GetResourceReportConfig, GetResourceReportIdConfig, NameToSlug, getUrlParamByKey, getUserInfoStorage, insertUrlParam } from "helpers/utilities"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect, useDispatch, useSelector } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import { Card, CardBody, Col, Row, TabContent, TabPane } from "reactstrap"
import { addNewFileResult } from "store/actions"
import {
    ApprovedValidAndPublishResult,
    SignTestResultResults,
    UnsignTestResultResults,
    clearTestResultDetail,
    getTestResultDetail, getTestResultResults, setLoadingChangeDetail
} from "store/laboratory/testResult/actions"
import LeftFrame from "./LeftFrame"
import SummaryInfo from "./SummaryInfo"
import TabHistory from "./TabHistory"
import TabResult from "./TabResult"
import TitleAndInfo from "./TitleAndInfo"
import { sendResultToZalo } from "helpers/app-backend/results_backend_helper"
import CheckExpireSADViettelModal from "./TabResult/Modal/CheckExpireSADViettelModal"
import { CheckIsExpiredViettel } from "helpers/app-backend/testResult_backend_helper"

const RESOURCE = ModuleIds.TestResult

const CardDetail = ({
    id,
    history,
    testResult = {},
    t,
    onGetTestResultDetail,
    onAddNewFileResult,
    onRefresh,
    onSetLoadingChangeDetail,
    loadingDetail,
    sticky,
    match,
    onApprovedValidAndPublishResult,
    onSignTestResultResults,
    onUnsignTestResultResults,
    isFastValidate,
    userValidate,
}) => {
    const [idResult, setIdResult] = useState(match.params.id)
    const [isClone, setIsClone] = useState(false)
    const [modal, setModal] = useState(false)
    const formEl = useRef(null)
    const formTable = useRef(null)
    const [currentTab, setCurrentTab] = useState(getUrlParamByKey('tab') || '1')
    const [actionState, setActionState] = useState('');
    const [open, setOpen] = useState(false)
    const [modalPreview, setModalPreview] = useState(false);
    const [testResultChange, setTestResultChange] = useState([])
    const [isSpin, setIsSpin] = useState(false)
    const [generalSetting, setGeneralSetting] = useState([])
    const [confirmSendResultModal, setConfirmSendResultModal] = useState(false)
    const isIntegration = generalSetting && generalSetting?.find(item => item.fieldName === 'IntegratedApproval')?.fieldValue === 'Integration'
    const smartCA = generalSetting && generalSetting?.find(item => item.fieldName === 'SmartCA')?.fieldValue || ""
    const item = localStorage.getItem("printResultConfig")
    const [printResultConfig, setPrintResultConfig] = useState({})
    const [reportResult, setReportResult] = useState({})
    const [reportType, setReportType] = useState([])
    const [countIsSelect, setCountIsSelect] = useState()
    const [isExpired, setIsExpired] = useState(false);

    const getPrintResultConfig = () => {
        if (item) {
            try {
                setPrintResultConfig(JSON.parse(item))
            } catch (error) {
                console.log('error', error)
            }
        }
    }

    useEffect(() => {
        getPrintResultConfig()
        window.addEventListener('storage', getPrintResultConfig)
        return () => {
            window.removeEventListener('storage', getPrintResultConfig)
        }
    }, [item])

    const dispatch = useDispatch()
    useEffect(() => {
        setCurrentTab(`${getUrlParamByKey('tab')}`)
        return () => {
            //xóa result cũ
            dispatch(clearTestResultDetail())
        }
    }, [])

    useEffect(() => {
        if (getUrlParamByKey('tab') != currentTab) {
            insertUrlParam({ tab: currentTab })
        }
    }, [currentTab])
    useEffect(() => {
        setCurrentTab(getUrlParamByKey('tab'))
    }, [window.location.search])
    const [rowEdit, setRowEdit] = useState({})
    const [confirmModal, setConfirmModal] = useState(false);
    const [authorizeVTModal, setAuthorizeVTModal] = useState(false);
    const toggleModal = () => {
        setModal(prev => !prev)
    }

    const { reportInfos } = useSelector(state => ({
        reportInfos: state.Authorization.reportinfo || [],
    }))

    useEffect(() => {
        if (printResultConfig.printReportEng) {
            setReportResult([reportInfos[1]])
        } else {
            setReportResult([reportInfos[0]])
        }
    }, [reportInfos, printResultConfig])

    useEffect(() => {
        if (loadingDetail == true) {
            setIsSpin(true)
        }
        else {
            setIsSpin(false)
        }
    }, [loadingDetail])

    useEffect(() => {
        if (idResult) {
            setIsSpin(true)
            setCurrentTab('1');
            onGetTestResultDetail({
                id: idResult, callback: () => {
                }
            })
        }
    }, [idResult])

    useEffect(() => {
        setModal(false)
    }, [testResult.id])

    useEffect(() => {
        if (testResult.id)
            onRefresh(testResult.id)
    }, [testResult.fileId])


    const onEditHandler = () => {
        setIsClone(false)
        toggleModal()
    }

    const onCloneHandler = () => {
        setIsClone(true)
        toggleModal()
    }

    const toggleParamModal = () => {
        setModal(prev => !prev)
    }

    useEffect(() => {
        setRowEdit(testResult)
    }, [testResult])

    const onDelete = () => {
        setConfirmModal(true)
    }

    const onDeleteToggleHandler = (e, param) => {
        setConfirmModal(false)
    }

    const onDeleteRequestsHandler = () => {
        onDeleteRequests({ requests: [testResult], callback: callback() })
    }

    const callback = () => {
        const url = `/TestResult`
        setConfirmModal(false)
        history.replace(url)
    }

    const PrintConfig = async (pageReport) => {
        if (reportResult.length > 0 && !isEmpty(reportResult[0].uri)) {
            let res
            if (!isFastValidate) {
                res = await getFilePrintResult({
                    ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, ""),
                    ResultId: `${testResult.id}`,
                    testIds: formTable?.current?.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable?.current?.GetAllIdsHasResult(),
                    page: pageReport?.length > 0 ? pageReport : formTable?.current?.GetReportType(),
                    SampleTypes: formTable?.current.GetSampleType()?.length > 0 ? formTable.current.GetSampleType() : formTable?.current?.GetAllSampleType(),
                    ValidatedBy: userValidate,
                    PrinterName: printResultConfig?.printerName,
                    IsPreview: '1'
                })
                onGetTestResultDetail(testResult.requestId)
            } else {
                const id = testResult.id
                const params = {
                    Module: ModuleIds.TestResult,
                    ItemAction: ReportAction.Create,
                    ItemValue: `${id}`,
                    reportParameters: {
                        ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, ""),
                        ResultId: `${testResult.id}`,
                        SampleTypes: formTable.current.GetSampleType()?.length > 0 ? formTable.current.GetSampleType() : formTable.current.GetAllSampleType(),
                    },
                    orderCode: testResult.alternateId,
                    medicalId: testResult.medicalId,
                    patientName: NameToSlug(testResult.patientName)
                }
                res = await confirmValidPrintVerSun({
                    ...GetDataUrlReportConfig(reportInfos, ReportResource.TestResult, ""),
                    ResultId: `${testResult.id}`,
                    testIds: formTable?.current?.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable?.current?.GetAllIdsHasResult(),
                    page: pageReport?.length > 0 ? pageReport : formTable?.current?.GetReportType(),
                    SampleTypes: formTable?.current?.GetSampleType()?.length > 0 ? formTable.current.GetSampleType() : formTable?.current?.GetAllSampleType(),
                    ValidatedBy: userValidate,
                    PrinterName: printResultConfig?.printerName,
                    IsPreview: '1'
                }, params)
                onGetTestResultDetail(testResult.requestId)
            }
            try {
                const getPingPrintService = await pingToPrintService();
                if (getPingPrintService.pingTime) {
                    const dataSendPrint = await sendDataPrint({
                        ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, ""),
                        "filePath": `${res.reportUrl}`,
                        "printerNameBarcode": printResultConfig.printerName
                        // "quantity": rowState.numberOfLabels
                    })
                    if (dataSendPrint === 'failed') {
                        if (isEmpty(printResultConfig.printerName)) {
                            showErrToast(
                                'Vui lòng chọn máy in'
                            )

                            setTimeout(() => {
                                window.open(process.env.REACT_APP_BASE_ENDPOINT + res?.reportUrl)
                            }, 1500)
                        } else {

                            let isPrint = true
                            let attempt = 0
                            const maxAttempts = 4
                            do {
                                const newRes = await getFilePrintResult({
                                    ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, ""),
                                    ResultId: `${testResult.id}`,
                                    testIds: formTable?.current?.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable?.current?.GetAllIdsHasResult(),
                                    page: pageReport?.length > 0 ? pageReport : formTable?.current?.GetReportType(),
                                    SampleTypes: formTable?.current.GetSampleType()?.length > 0 ? formTable.current.GetSampleType() : formTable?.current?.GetAllSampleType(),
                                    ValidatedBy: userValidate,
                                    PrinterName: printResultConfig?.printerName,
                                    IsPreview: '1'
                                })

                                const dataSendPrint = await sendDataPrint({
                                    ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, ""),
                                    "filePath": `${newRes.reportUrl}`,
                                    "printerNameBarcode": printResultConfig.printerName
                                    // "quantity": rowState.numberOfLabels
                                })
                                if (dataSendPrint !== 'failed') {
                                    isPrint = false
                                }
                                attempt++;
                                if (attempt >= maxAttempts) {
                                    isPrint = false
                                }
                            } while (isPrint)
                        }
                    } else {
                        await getFilePrintResult({
                            ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, ""),
                            ResultId: `${testResult.id}`,
                            testIds: formTable.current.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable.current.GetAllIdsHasResult(),
                            page: pageReport?.length > 0 ? pageReport : formTable?.current?.GetReportType(),
                            SampleTypes: formTable.current.GetSampleType()?.length > 0 ? formTable.current.GetSampleType() : formTable.current.GetAllSampleType(),
                            ValidatedBy: userValidate,
                            PrinterName: printResultConfig.printerName,
                            IsPreview: '1',
                            PrintSuccess: '1'
                        })
                        onGetTestResultDetail(testResult.requestId)
                    }
                } else {
                    window.open(process.env.REACT_APP_BASE_ENDPOINT + res?.reportUrl)
                }
                onGetTestResultDetail(testResult.requestId)
            }
            catch {
                window.open(process.env.REACT_APP_BASE_ENDPOINT + res?.reportUrl)
                onGetTestResultDetail(testResult.requestId)
            }
            // let url = process.env.REACT_APP_BASE_ENDPOINT + res?.reportUrl
            // let fileName = `${testResult.alternateId}_${NameToSlug(testResult.patientName)}_${testResult.medicalId}.${ExportExtension.pdf}`;
            // let htmlString = `
            //             <html>

            // <head>
            //         <title>${fileName}</title>
            // </head>

            // <body>
            //         <iframe src="${url}"
            //                 style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;">
            //                 Your browser doesn't support iframes
            //         </iframe>
            // </body>

            // </html>
            //             `
            // var wnd = window.open('', "");
            // wnd.document.write(htmlString);
            // wnd.document.close()
            onRefresh(testResult.id)
        }
        else {
            const print = localStorage.getItem("printConfig")
            if (isEmpty(print)) {
                setOpen(true)
            }
            else {
                setModalPreview(true);
            }
        }
    }

    const onPrintHandler = (state, pageReport) => {
        setActionState(state)
        PrintConfig(pageReport)
    }
    const onPreviewHandler = (state) => {
        setActionState(state)
        setModalPreview(true);

    }
    const onExportHandler = async (state) => {
        setActionState(state)
        const id = testResult.id
        let page = formTable.current.GetReportType()?.length > 0 ? formTable.current.GetReportType() : formTable.current.GetAllReportType()
        let pageFormat = page.join(",")
        const params = {
            Module: ModuleIds.TestResult,
            ItemAction: ReportAction.Export,
            ItemValue: `${id}`,
            reportParameters: {
                ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, testResult.fileId),
                "ResultId": `${id}`,
                "exportFormat": ExportExtension.pdf,
                Page: pageFormat,
                hasSignature: "false"
            },
            orderCode: testResult.alternateId,
            medicalId: testResult.medicalId,
            patientName: NameToSlug(testResult.patientName)
        }
        const data = {
            ResultId: id,
            reportId: GetResourceReportIdConfig(reportResult),
            testIds: formTable?.current?.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable?.current?.GetAllIdsHasResult(),
        }
        const res = await exportFileResult(data, params)
        if (res.length > 0) {
            res.forEach(async element => {
                await downloadFileWithName(element)
            });
        }

    }

    const onReportSettingHandler = (state) => {
        setOpen(true);
    }

    const onCreateHandler = (state) => {
        setActionState(state)
        if (isIntegration) {
            setConfirmSendResultModal(true)
        } else {
            onCreateReport(testResult.id)
        }
    }
    const onCreateReport = async (id) => {
        const params = {
            Module: ModuleIds.TestResult,
            ItemAction: ReportAction.Create,
            ItemValue: `${id}`,
            reportParameters: {
                ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, testResult.fileId),
                ResultId: `${testResult.id}`,
                hasSignature: "false",
                SampleTypes: formTable.current.GetAllSampleTypeHasResult() || [],
            },
            orderCode: testResult.alternateId,
            medicalId: testResult.medicalId,
            patientName: NameToSlug(testResult.patientName)
        }
        const data = {
            ResultId: id,
            reportId: GetResourceReportIdConfig(reportResult),
            testIds: formTable?.current?.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable?.current?.GetAllIdsHasResult(),
        }

        if (isIntegration) {
            onApprovedValidAndPublishResult({
                data: {
                    data, params
                }, callback: (id) => {
                    showToast(
                        `${t("message:SendingReportSucceeded")}`, true
                    )
                    onGetTestResultDetail(testResult.requestId)
                    setConfirmSendResultModal(prev => !prev)
                }
            })
        } else {
            onAddNewFileResult({
                data: {
                    data, params
                }, callback: () => {
                    onGetTestResultDetail(testResult.requestId)
                }
            })
        }
    }

    const onSendZaloClick = async (pageReport) => {
        const res = await sendResultToZalo({
            ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, ""),
            ResultId: `${testResult.id}`,
            testIds: formTable?.current?.GetIsPrintIds()?.length > 0 ? formTable.current.GetIsPrintIds() : formTable?.current?.GetAllIdsHasResult(),
            page: pageReport?.length > 0 ? pageReport : formTable?.current?.GetReportType(),
            SampleTypes: formTable?.current.GetSampleType()?.length > 0 ? formTable.current.GetSampleType() : formTable?.current?.GetAllSampleType(),
            ValidatedBy: userValidate,
            PrinterName: printResultConfig?.printerName,
            IsPreview: '1',
            phoneNumber: testResult?.phone ?? ""
        });
        if (res.success) {
            showToast(
                `${res.message}`, false
            )
        } else {
            showToast(
                `${res.message}`, true
            )
        }
    }

    const onSign = async (state) => {
        //kiểm tra hết hạn viettel
        if (smartCA == 'Viettel') {
            let userId = getUserInfoStorage("sub")
            let checkExpired = await CheckIsExpiredViettel({ UserId: userId })
            setIsExpired(checkExpired.isExpired)
            if (checkExpired && (checkExpired.isExpired == true || checkExpired.isExpired == null)) {
                setAuthorizeVTModal(true)
                return;
            }
        }
        setActionState(state)
        const id = testResult.id
        let page = formTable.current.GetReportType()?.length > 0 ? formTable.current.GetReportType() : formTable.current.GetAllReportType()
        let pageFormat = page.join(",")
        const params = {
            Module: ModuleIds.TestResult,
            ItemAction: ReportAction.Export,
            ItemValue: `${id}`,
            reportParameters: {
                ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, testResult.fileId),
                "ResultId": `${id}`,
                "exportFormat": ExportExtension.pdf,
                Page: pageFormat,
                SampleTypes: formTable.current.GetAllSampleTypeHasResult() || [],
            },
            orderCode: testResult.alternateId,
            medicalId: testResult.medicalId,
            patientName: NameToSlug(testResult.patientName)
        }
        const data = {
            id: id,
            reportId: GetResourceReportIdConfig(reportResult),
            testResultIds: formTable.current.GetIsValidIds() || [],
            request: params || {}
        }
        onSignTestResultResults(data, () => {
            formTable?.current?.AfterUpdate()
        })

    }

    const onUnsign = async (state) => {
        setActionState(state)
        const id = testResult.id
        let page = formTable.current.GetReportType()?.length > 0 ? formTable.current.GetReportType() : formTable.current.GetAllReportType()
        console.log("🚀 ~ onSendZaloClick ~ page:", page)
        console.log("🚀 ~ onSendZaloClick ~ page:", page)
        let pageFormat = page.join(",")
        const params = {
            Module: ModuleIds.TestResult,
            ItemAction: ReportAction.Export,
            ItemValue: `${id}`,
            reportParameters: {
                ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, testResult.fileId),
                "ResultId": `${id}`,
                "exportFormat": ExportExtension.pdf,
                Page: pageFormat,
            },
            orderCode: testResult.alternateId,
            medicalId: testResult.medicalId,
            patientName: NameToSlug(testResult.patientName)
        }
        const data = {
            id: id,
            reportId: GetResourceReportIdConfig(reportResult),
            testResultIds: formTable.current.GetIsValidIds() || [],
            request: params || {}
        }
        onUnsignTestResultResults(data, () => {
            formTable?.current?.AfterUpdate()
        })

    }

    const checkReportType = () => {
        let count_check = 0
        let res = [];
        let reportTypeNames = [];
        testResultChange.forEach(element => {
            if (element.type == TestRequest_Test_Type.TEST) {
                if (element.isValid == true) {
                    count_check++
                    let reportTypeName = element.reportTypeName
                    if (element.state !== RESULT_STATE_Text.Canceled || element.state !== RESULT_STATE_Text.RDS && reportTypeName !== "" && !reportTypeNames.includes(reportTypeName)) {
                        res.push(reportTypeName);
                        reportTypeNames.push(reportTypeName);
                    }
                }
            }
            if (element.children && element.children.length > 0) {
                element.children.forEach(parent => {
                    if (parent.type == TestRequest_Test_Type.TEST) {
                        if (parent.isValid == true) {
                            count_check++;
                            let reportTypeName = parent.reportTypeName
                            if (parent.state !== RESULT_STATE_Text.Canceled || parent.state !== RESULT_STATE_Text.RDS && reportTypeName !== "" && !reportTypeNames.includes(reportTypeName)) {
                                res.push(reportTypeName);
                                reportTypeNames.push(reportTypeName);
                            }
                        }
                    }
                    if (parent.children && parent.children.length > 0) {
                        parent.children.forEach(child => {
                            if (child.type == TestRequest_Test_Type.TEST) {
                                if (child.isValid == true) {
                                    count_check++
                                    let reportTypeName = child.reportTypeName
                                    if (child.state !== RESULT_STATE_Text.Canceled || child.state !== RESULT_STATE_Text.RDS && reportTypeName !== "" && !reportTypeNames.includes(reportTypeName)) {
                                        res.push(reportTypeName);
                                        reportTypeNames.push(reportTypeName);
                                    }
                                }
                            }
                        });
                    }
                });
            }
        });
        setCountIsSelect(count_check);
        setReportType(reportTypeNames)
    }
    useEffect(() => {
        checkReportType()
    }, [testResultChange])

    const refHeader = useRef(null)
    // if (isEmpty(testResult)) return null;


    return (
        <React.Fragment>
            {/* <ModalConfigPrinter open={open} onClose={(state) => {

                setOpen(false)
            }}
                stateAction={actionState}
                resource={GetResourceReportConfig(reportInfos)}
                onPreviewClick={(state) => { onPreviewHandler(state) }}
                onPrintClick={(state) => { onPrintHandler(state) }}
                onExportClick={(state) => { onExportHandler(state) }}
            /> */}
            {modalPreview &&
                <ModalPreview
                    modal={modalPreview}
                    toggle={() => { setModalPreview(false) }}
                    fileId={testResult.fileId}
                    reportId={GetResourceReportIdConfig(reportResult)}
                    resourceReport={ReportResource.TestResult}
                    dataUrl={
                        {
                            ...GetDataUrlReportConfig(reportResult, ReportResource.TestResult, testResult.fileId),
                            "ResultId": `${testResult.id}`,
                            testIds: formTable?.current?.GetIsPrintIds()?.length > 0 ? formTable?.current?.GetIsPrintIds() : formTable?.current?.GetAllIds(),
                            page: countIsSelect > 0 ? reportType : formTable?.current?.GetAllReportType(),
                            SampleTypes: formTable?.current?.GetSampleType()?.length > 0 ? formTable.current?.GetSampleType() : formTable?.current?.GetAllSampleType(),
                            ValidatedBy: userValidate,
                            IsPreview: '0'
                        }}
                />
            }
            <div id="result-header-detail" className="" ref={refHeader}>
                <Row>
                    <Col lg="12" className="px-0">
                        {testResult &&
                            <div className={sticky ? 'header-result-detail' : 'sticky-header-detail-expand header-result-detail'}>
                                <TitleAndInfo
                                    generalSetting={generalSetting}
                                    onEdit={onEditHandler}
                                    onClone={onCloneHandler}
                                    data={testResult}
                                    title={t("Test Result")}
                                    currentTab={currentTab}
                                    subtitle={<>
                                        {testResult.sid ?
                                            <Link to={`/TestRequest/${testResult.requestId}/view?tab=1`} target="_blank">{`${testResult.sid}`}</Link>
                                            :
                                            <span>{t("Result Title")}</span>
                                        }
                                    </>
                                    }
                                    resource={RESOURCE}
                                    onDelete={onDelete}
                                    resourceReport={GetResourceReportConfig(reportResult)}
                                    onCreateClick={(state) => { onCreateHandler(state) }}
                                    onPrintClick={(state, pageReport) => { onPrintHandler(state, pageReport) }}
                                    onReportSettingClick={(state) => { onReportSettingHandler(state) }}
                                    onPreviewClick={(state) => { onPreviewHandler(state) }}
                                    onSendZaloClick={(pageReport) => { onSendZaloClick(pageReport) }}
                                    onExportClick={(state) => { onExportHandler(state) }}
                                    // onExportClick={(state) => { onExportHandler(state) }}
                                    testResults={testResultChange || []}
                                />
                            </div >}
                    </Col >
                </Row >
            </div >
            <div className="row" style={{ height: "calc(100% - 60px)", paddingTop: 5 }}>
                <CustomSplitPane
                    LeftFrame={() => (
                        <div className="h-100 header-fixed" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                            <LeftFrame
                                onGeneralSetting={(val) => {
                                    setGeneralSetting(val)
                                }}
                                onChangeResult={newId => {
                                    if (idResult != newId)
                                        setIdResult(newId)
                                }}
                            />
                            <div className="result-detail-bottom-column">&nbsp;</div>
                        </div>
                    )}
                    RightFrame={() => (
                        <>
                            <div style={{ height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                                <div className="header-result-detail sumamry-info-result-detail">
                                    <SummaryInfo
                                        data={testResult}
                                        createdByName={testResult.createdByName}
                                        updatedByName={testResult.updatedByName}
                                        generalSetting={generalSetting}
                                    />
                                </div>
                                <Row className="flex-1" style={{ overflow: 'hidden' }}>
                                    {isSpin &&
                                        <div className=" w-100" style={{
                                            height: '93%',
                                            position: 'absolute', zIndex: 9,
                                            background: 'rgba(256,256,256,0.5)'
                                        }}>
                                            <div className="w-100 " style={{ height: '93%' }}>
                                                <div className="text-center" style={{ marginTop: '50px' }}>
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <Col lg="12" className="h-100">
                                        <Card className="h-100">
                                            <CardBody className="h-100 pb-0" style={{ padding: '10px' }}>
                                                <div className="h-100" style={{ position: 'relative' }}>
                                                    <div className="d-none">
                                                        <SystemInformation t={t} data={rowEdit} />
                                                    </div>
                                                    <Row className="h-100">
                                                        <CustomNav
                                                            onToggle={e => {
                                                                if (e == "1") {
                                                                    setTimeout(() => {
                                                                        setCurrentTab(e);
                                                                        formTable.current?.ReSetColumns()
                                                                    }, 400);
                                                                }
                                                                else {
                                                                    setCurrentTab(e);
                                                                }
                                                                // setCurrentTab(e);
                                                            }}
                                                            defaultTab={currentTab}
                                                            tabs
                                                            className="nav-tabs-custom"
                                                            //onToggle={onGetTestRequestSample}
                                                            tabContents={customActiveTab => (
                                                                <TabContent
                                                                    activeTab={customActiveTab}
                                                                    className="p-3 text-muted pb-0"
                                                                    style={{ height: "calc(100% - 41px)" }}
                                                                >
                                                                    <TabPane tabId="1" className="h-100">
                                                                        {testResult.id && currentTab == "1" &&
                                                                            <TabResult className="testsTab"
                                                                                isEdit={!isClone}
                                                                                // onValidSubmit={onValidSubmitTestsTab}
                                                                                data={[]}
                                                                                id={testResult.id}
                                                                                requestId={testResult.requestId}
                                                                                onRefreshDetail={() => { }}
                                                                                onChange={(values) => {
                                                                                    setTestResultChange(values)
                                                                                }}
                                                                                currentTab={currentTab}
                                                                                generalSetting={generalSetting}
                                                                                ref={formTable}
                                                                                onSign={(state) => { onSign(state) }}
                                                                                onUnsign={(state) => { onUnsign(state) }}
                                                                                resourceReport={GetResourceReportConfig(reportResult)}
                                                                            />}
                                                                    </TabPane>
                                                                    <Check permission={permissionType.R} resource={'Logs'}>
                                                                        <TabPane tabId="2" className="h-100">
                                                                            {(testResult.id) && currentTab == "2" &&
                                                                                <div className=" h-100 tab-history-detail-result">
                                                                                    <TabHistory className="testsTab"
                                                                                        id={testResult.id}
                                                                                        currentTab={currentTab}
                                                                                    />
                                                                                </div>}
                                                                        </TabPane>
                                                                    </Check>
                                                                </TabContent>
                                                            )}
                                                        >
                                                            <CustomNavLink tabId={'1'}>
                                                                <span className="">{t(`common:Detail`)}</span>
                                                            </CustomNavLink>

                                                            <CustomNavLink tabId={'2'}>
                                                                <Check permission={permissionType.R} resource={'Logs'}>
                                                                    <span className="">{t(`History`)}</span>
                                                                </Check>
                                                            </CustomNavLink>
                                                        </CustomNav>
                                                    </Row>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <div className="result-detail-bottom-column">&nbsp;</div>
                            </div>
                        </>
                    )}
                    InitialSize={70}
                />
            </div>
            <ConfirmModal
                modal={confirmModal}
                title={`${t("common:Delete")} ${t("Test Result")}`}
                message={`${t("message:DeleteRecordConfirm", {
                    entity: `${t("Test Result")}`,
                })}`}
                onToggle={onDeleteToggleHandler}
                onDelete={onDeleteRequestsHandler}
            />
            <ConfirmModal2
                modal={confirmSendResultModal}
                title={`${t("Result")}`}
                message={`${t("testResultPage:Approved Valid Publish")}`}
                onToggle={() => setConfirmSendResultModal(prev => !prev)}
                onConfirm={() => { onCreateReport(testResult.id) }}
                btnConfirmText={t("Ok")}
                isEdit={true}
            />
            <CheckExpireSADViettelModal
                modal={authorizeVTModal}
                toggle={() => setAuthorizeVTModal(prev => !prev)}
                isExpired={isExpired}
            />
        </React.Fragment >
    )
}

const ListTabName = [
    {
        id: 1,
        name: 'common:Detail'
    },
    {
        id: 2,
        name: 'History'
    },
]

CardDetail.propTypes = {
    testResult: PropTypes.object,
    onGetTestResultDetail: PropTypes.func,
    t: PropTypes.any,
}

const mapStateToProps = ({ testResult }) => {
    return ({
        testResult: testResult.testResult,
        loadingDetail: testResult.loadingDetail || false,
        isFastValidate: testResult.isFastValidate,
        userValidate: testResult.userValidate
    })
}


const mapDispatchToProps = dispatch => ({
    onGetTestResultDetail: id => dispatch(getTestResultDetail(id)),
    onRefresh: (id, callback) => dispatch(getTestResultResults({ id, callback })),
    onAddNewFileResult: (data, callback) => dispatch(addNewFileResult(data, callback)),
    onSetLoadingChangeDetail: (data) => dispatch(setLoadingChangeDetail(data)),
    onApprovedValidAndPublishResult: (data, callback) => dispatch(ApprovedValidAndPublishResult(data, callback)),
    onSignTestResultResults: (data, callback) => dispatch(SignTestResultResults(data, callback)),
    onUnsignTestResultResults: (data, callback) => dispatch(UnsignTestResultResults(data, callback)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withTranslation(["testResultPage", "common"])(CardDetail)))